if (!customElements.get("product-recommendations")) {
    class e extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.initializeRecommendations();
        }
        initializeRecommendations() {
            new IntersectionObserver(
                ((e, t) => {
                    if (!e[0].isIntersecting) return;
                    t.unobserve(this);
                    const n = window.matchMedia("(max-width: 749px)").matches
                        ? this.dataset.urlMobile || this.dataset.url
                        : this.dataset.urlDesktop || this.dataset.url;
                    fetch(n)
                        .then((e) => e.text())
                        .then((e) => {
                            const t = document.createElement("div");
                            t.innerHTML = e;
                            const n = t.querySelector("product-recommendations");
                            n &&
                                n.innerHTML.trim().length &&
                                ((this.innerHTML = n.innerHTML),
                                "function" == typeof initProductImageSliders && initProductImageSliders(this),
                                
                                // Trustpilot's
                                reinitTrustpilotWidgets(this),

                                this.dispatchEvent(
                                    new CustomEvent("recommendations:loaded", { bubbles: !0, detail: { root: this } })
                                )),
                                t.querySelector(".card") && this.classList.add("product-recommendations-loaded");
                        })
                        .catch((e) => {
                            console.error(e);
                        });
                }).bind(this),
                { rootMargin: "0px 0px 200px 0px" }
            ).observe(this);
        }
    }
    customElements.define("product-recommendations", e);
}
